import React, { useState } from "react";
import axios from "axios";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";

const Login = () => {
  const [codigo, setCodigo] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!codigo.trim() || !email.trim() || !password.trim()) {
      alert("Todos los campos son obligatorios");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        {
          codigo,
          email,
          password,
        }
      );

      if (response.data.status) {
        const {
          token,
          id_usuario,
          rol,
          name,
          empresa,
          numeroElementosTablalistado,
          idTarifaActiva,
        } = response.data;

        // Guardar token y datos en localStorage
        localStorage.setItem(process.env.REACT_APP_TOKEN_KEY, token);
        localStorage.setItem(process.env.REACT_APP_ID_USUARIO_KEY, id_usuario);
        localStorage.setItem(process.env.REACT_APP_ROL_KEY, rol);
        localStorage.setItem(process.env.REACT_APP_NOMBRE_KEY, name);
        localStorage.setItem(process.env.REACT_APP_EMPRESA_KEY, empresa);

        // Redirige a la página principal
        window.location.href = "/";
      }
    } catch (err) {
      alert("Credenciales Incorrectas");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 0,
        margin: 0,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 2,
          width: "100%",
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 3,
          }}
        >
          <img
            src={process.env.REACT_APP_LOGO}
            alt="Logo Empresa"
            style={{
              maxWidth: "100%",
              height: "auto",
              maxHeight: 100,
            }}
          />
        </Box>
        <Typography variant="h5" gutterBottom>
          ¡Bienvenido!
        </Typography>
        <Typography variant="body1" gutterBottom>
          Inicia sesión para continuar
        </Typography>
        <Box component="form" onSubmit={handleLogin} noValidate>
          <TextField
            label="Código de Empresa"
            variant="outlined"
            fullWidth
            margin="normal"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value.toUpperCase())}
            inputProps={{ maxLength: 5 }}
            required
          />
          <TextField
            label="Correo Electrónico"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            sx={{ marginTop: 2 }}
          >
            Acceder
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
